import React from "react";
import { useTranslation } from "react-i18next";
import Block from "../../Block";
import FormGroup from "../../forms/FormGroup";
import FormRowCol from "../../forms/FormRowCol";
import BoolSelect from "../../forms/inputs/BoolSelect";

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
};

export default function OptOut({ getInputProps, formRefValues }) {
  const { t } = useTranslation();

  return (
    <Block title={t("dataVendor.optOut")}> 
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        label={t("dataVendor.withOptOut")}
        {...getInputProps("with_opt_out")}
      >
        <BoolSelect />
      </FormGroup>
    </Block>
  );
}
